import React, { useEffect } from "react";
import Advertiser1 from "../media/salesman.jpg";
import Advertiser2 from "../media/helper.jpg";
import Advertiser3 from "../media/leaner.jpg";
import Advertiser4 from "../media/security.jpg";
import Advertiser5 from "../media/distributor-job.jpg";

const Career = () => {
  const jobsAdv = [
    {
      title: "Salesman for Water Bottles",
      img: Advertiser1,
      description:
        "We need a friendly and active Salesman to sell our water bottles. Help us reach more people and grow our business.",
      phoneNumber: "+91 7078430767",
      requirements: [
        "Good speaking skills.",
        "Experience in sales is a plus.",
        "Can work alone and achieve targets.",
      ],
    },
    {
      title: "Helper",
      img: Advertiser2,
      description:
        "Join us to help with daily tasks like moving items, keeping things in order, and helping the team.",
      phoneNumber: "+91 7078430767",
      requirements: [
        "Physically fit to do tasks.",
        "Ready to work with the team.",
        "Basic organizing skills.",
      ],
    },
    {
      title: "Cleaning Staff",
      img: Advertiser3,
      description:
        "We are hiring cleaning staff to keep our place clean and neat. Make sure the area is healthy and tidy.",
      phoneNumber: "+91 7078430767",
      requirements: [
        "Careful about cleanliness.",
        "Know how to use cleaning tools.",
        "Can work alone or with others.",
      ],
    },
    {
      title: "Security Guard",
      img: Advertiser4,
      description:
        "We need a Security Guard to keep our place safe. Watch over the area and control who comes and goes.",
      phoneNumber: "+91 7078430767",
      requirements: [
        "Experience in security is good.",
        "Stay calm during emergencies.",
        "Good at watching and reporting.",
      ],
    },
    {
      title: "Distributor for Water Bottles",
      img: Advertiser5,
      description:
        "We are looking for distributors to sell our water bottles. Partner with us and grow your business.",
      phoneNumber: "+91 7078430767",
      requirements: [
        "Experience in distribution or wholesale.",
        "Can invest money.",
        "Ready to promote our brand.",
      ],
    },
  ];

  useEffect(() => {
    // Scroll to top when this page is rendered
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="container my-5">
        {/* Header */}
        <h1 className="text-center text-primary mb-4">
          Join Our Team - Exciting Job Opportunities
        </h1>
        <p className="text-center mb-5">
          Be a part of <strong>Waters</strong> and grow with us. We have jobs
          for everyone ready to make a change.
        </p>

        {/* Job Listings */}
        <ul className="list-group">
          {jobsAdv.map((job, index) => (
            <li
              key={index}
              className="list-group-item p-4 mb-4 border shadow-sm"
            >
              <div className="row align-items-center">
                {/* Job Image */}
                <div className="col-md-2 text-center">
                  <img
                    src={job.img}
                    alt={job.title}
                    className="img-fluid rounded-circle"
                    style={{ maxWidth: "200px" }}
                  />
                </div>

                {/* Job Details */}
                <div className="col-md-7">
                  <h3 className="text-success">{job.title}</h3>
                  <p>{job.description}</p>

                  <div>
                    <h5>Requirements:</h5>
                    <ul className="ps-3">
                      {job.requirements.map((req, idx) => (
                        <li key={idx} className="mb-1">
                          <i className="bi bi-check-circle-fill text-success me-2"></i>
                          {req}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="col-md-3 text-center">
                  <a
                    href={`tel:${job.phoneNumber}`}
                    className="btn btn-outline-primary mb-2 w-75"
                  >
                    <i className="bi bi-telephone-fill me-1"></i> Call Now
                  </a>
                  <a
                    href="https://chat.whatsapp.com/KIq9w9J2USyJ2skoQ1piDK"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-success w-75"
                  >
                    <i className="bi bi-whatsapp me-1"></i> Apply on WhatsApp
                  </a>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Career;
